import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets/about-us/team-member_0.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "row content-buttons"
}
const _hoisted_7 = {
  key: 0,
  class: "col"
}
const _hoisted_8 = ["href", "target"]
const _hoisted_9 = {
  key: 1,
  class: "content-images"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 2,
  class: "position-relative content-block"
}
const _hoisted_12 = { class: "container-fluid container-lg py-5" }
const _hoisted_13 = {
  key: 3,
  class: "row content-team-list pt-4"
}
const _hoisted_14 = { class: "col-sm col-lg-6 py-4" }
const _hoisted_15 = { class: "row team-member" }
const _hoisted_16 = { class: "col-sm col-lg-6 py-lg-4" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = {
  key: 1,
  src: _imports_0,
  class: "rounded-circle",
  alt: ""
}
const _hoisted_19 = { class: "col-sm col-lg-6 py-lg-4" }
const _hoisted_20 = {
  key: 0,
  class: "team-member-title"
}
const _hoisted_21 = ["innerHTML"]

import ContentBlockFlowpart from "@/components/general/ContentBlockFlowpart.vue"
    import { ref, Ref, onMounted } from "vue"
    import { CmsBaseUrl } from "@/utils/functions"
    import { getContentBlock } from "@/utils/graphql"
    import { contentBlockObj } from '@/utils/graphql/contentblock'
    import { useApolloClient } from '@vue/apollo-composable'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ContentBlock',
  props: {
        alias: {type: String, default: null},
        content: {type: Object, default: null},
        isPageTitle: {type: Boolean, default: false},
        subtitleFirst: {type: Boolean, default: false}
    },
  setup(__props) {

    const props = __props
    var blockContent: Ref<any | undefined> = ref(undefined)
    const { resolveClient } = useApolloClient()
    const ApolloClient = resolveClient()
    
    function isValidLink (url: String) {
        return url != null && url != ""
    }
    
    function isExternalLink (url: String) {
        return ["http", "mailto-", "tel-"].some(el => url.includes(el))
    }
    
    function isAnchorLink (url: String) {
        return url.includes('http')
    }
    
    function formatContactLink (url: String) {
        return url.replaceAll("mailto-", "mailto:").replaceAll("tel-", "tel:")
    }

    function getHtmlContent() {
        if(blockContent.value.markdownBody) {
            return blockContent.value.markdownBody.html.replaceAll("src=\"/media/" , `class=\"img-fluid\" src=\"${CmsBaseUrl()}/media/`)
        }
    }

    onMounted(async () => {
        if(props.alias != null) {
            await getContentBlock(ApolloClient, props.alias).then(res => {
                blockContent.value = res as contentBlockObj
            });
        }
        else if(props.content != null) {
            blockContent.value = props.content
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(blockContent))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(__props.alias + '-content content-body')
      }, [
        (_unref(blockContent).contentBlockTitle || _unref(blockContent).contentBlockSubtitle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['content-title', {'subtitle-first': __props.subtitleFirst}])
            }, [
              (_unref(blockContent).contentBlockTitle)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (__props.isPageTitle)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, _toDisplayString(_unref(blockContent).contentBlockTitle), 1))
                      : (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_unref(blockContent).contentBlockTitle), 1))
                  ], 64))
                : _createCommentVNode("", true),
              (_unref(blockContent).contentBlockSubtitle)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (__props.isPageTitle)
                      ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_unref(blockContent).contentBlockSubtitle), 1))
                      : (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_unref(blockContent).contentBlockSubtitle), 1))
                  ], 64))
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        (_unref(blockContent).markdownBody.html)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              innerHTML: getHtmlContent(),
              class: "mb-4"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        (_unref(blockContent).additionalContent && _unref(blockContent).additionalContent.contentItems)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(blockContent).additionalContent.contentItems, (content) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (content.__typename == 'Buttons')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.buttonList.contentItems, (buttons, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (isValidLink(buttons.linkMenuItem.url))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                (isAnchorLink(buttons.linkMenuItem.url))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: formatContactLink(buttons.linkMenuItem.url),
                                      class: "btn btn-outline-dark text-uppercase rounded-0 py-2 d-flex align-items-center justify-content-center",
                                      target: isExternalLink(buttons.linkMenuItem.url) ? '_blank' : ''
                                    }, _toDisplayString(buttons.linkMenuItem.name), 9, _hoisted_8))
                                  : (_openBlock(), _createBlock(_component_router_link, {
                                      key: 1,
                                      to: buttons.linkMenuItem.url,
                                      class: "btn btn-outline-dark text-uppercase rounded-0 py-2 d-flex align-items-center justify-content-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(buttons.linkMenuItem.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ]))
                  : (content.__typename == 'Image' && content.images.urls && content.images.urls.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.images.urls, (image, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (content.images.urls != '')
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "img-fluid",
                                  src: _unref(CmsBaseUrl)() + image,
                                  alt: ""
                                }, null, 8, _hoisted_10))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ]))
                    : (content.__typename == 'ContentBlockFlowpart' && content.markdownBody.html)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(ContentBlockFlowpart, { content: content }, null, 8, ["content"])
                          ])
                        ]))
                      : (content.__typename == 'TeamList' && content.team && content.team.contentItems.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.team.contentItems, (team) => {
                              return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, [
                                    (team.image.urls.length > 0)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: _unref(CmsBaseUrl)() + team.image.urls[0],
                                          class: "img-fluid rounded-circle",
                                          alt: team.displayText
                                        }, null, 8, _hoisted_17))
                                      : (_openBlock(), _createElementBlock("img", _hoisted_18))
                                  ]),
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("h3", null, _toDisplayString(team.displayText), 1),
                                    (team.jobTitle)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(team.jobTitle), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", {
                                      innerHTML: team.bio.html
                                    }, null, 8, _hoisted_21)
                                  ])
                                ])
                              ]))
                            }), 256))
                          ]))
                        : _createCommentVNode("", true)
              ], 64))
            }), 256))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})